import { useState } from "react";
import TabThirdParty from "./tabThirdParty";

const TabLine = ({ items }: any) => {
  // const [value, setValue] = useState(0);
  return (
    <>
      <TabThirdParty
        // value={value}
        // setValue={setValue}
        items={items}
      />
    </>
  );
};

export default TabLine;
